// Account settings live on the account portal's preferences page, as in
// platform's console.
export function accountPreferencesUrl(portalUrl: string): string {
    return `${portalUrl.replace(/\/+$/, "")}/me/preferences`;
}
